import styled, { css } from 'styled-components';
export const PlanTileToggleContainer = styled.div `
  display: flex;
  flex-direction: row;
  gap: 0;
  align-items: stretch;
  border: 2px solid ${({ theme }) => theme.colors.grey_5};
  border-radius: 4px;
  width: max-content;
  height: fit-content;

  ${({ $color, theme }) => css `
    background: ${$color || theme.colors.grey_5};
  `};
`;
export const PlanTileToggleItem = styled.div `
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: 8px;
  padding-block: 4px;
  cursor: pointer;
  ${({ $active, theme }) => $active
    ? css `
          background-color: ${theme.colors.white_1};
        `
    : css ``};
`;
export const LineItemContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.appearance.spacing * 1.5}px;
  p {
    margin-block: 0;
  }
`;
